// Framework and third-party non-UI
import React from 'react';

// Redux, contexts, and local helpers/utils/modules

// Component specific modules (Component-styled, etc.)

// App components

// Third-party components (buttons, icons, etc.)
import { CalciteTextArea } from '@esri/calcite-components-react';

type CalciteTextAreaProps = React.ComponentProps<typeof CalciteTextArea>;

export interface CalciteTextAreaWrapperProps
  extends Omit<CalciteTextAreaProps, 'value' | 'onChange'> {
  value: string;
  onChange?: (value: string) => void;
}

const CalciteTextAreaWrapper: React.FC<CalciteTextAreaWrapperProps> =
  React.forwardRef(({ disabled, value, onChange, ...rest }, ref) => {
    const onCalciteTextAreaInput = (e: any) => {
      if (onChange) onChange((e.target as HTMLCalciteTextAreaElement).value);
    };

    return (
      <CalciteTextArea
        disabled={disabled || undefined}
        value={value}
        onCalciteTextAreaInput={onCalciteTextAreaInput}
        ref={ref}
        {...rest}
      />
    );
  });

export default CalciteTextAreaWrapper;
